module.exports = __webpack_public_path__ + "static/media/pag-QueroSerLojista-ebit-02.bd76bf14.bd76bf14.png";